// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Movement = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.125}
      d="M13.5 5.625 16.875 9 13.5 12.375M10.125 9h6.75M4.5 12.375 1.125 9 4.5 5.625M7.875 9h-6.75"
    />
  </svg>
);
const ForwardRef = forwardRef(Movement);
export default ForwardRef;
